<template>
    <div class="form-group">
        <input class="checkbox"
               type="checkbox"
               :value="value"
               :id="getFieldId"
               :name="name">
        <span v-text="placeholder"></span>
    </div>
</template>
<script>

    let InputField = require('@/mixins/InputField');

    export default {

        mixins: [InputField],

        methods: {
            updateStatus(value) {
                this.$emit('input', value)
            },
        },
    }
</script>